
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4LH4L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b849d85222b8bab1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $b849d85222b8bab1$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Avbryt',
    'fabric.linkPicker.button.insert': 'Infoga',
    'fabric.linkPicker.button.save': 'Spara',
    'fabric.linkPicker.clearLink': 'Rensa',
    'fabric.linkPicker.clearLinkText': 'Rensa text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {inga resultat hittades} one {{count,number} resultat hittades} other {{count,number} resultat hittades}}',
    'fabric.linkPicker.linkAriaLabel': "Skriv eller klistra in en l\xe4nk i f\xe4ltet",
    'fabric.linkPicker.linkHelperTextAriaLabel': "Visningstext f\xf6r l\xe4nk",
    'fabric.linkPicker.linkHelperTextLabel': "Ge l\xe4nken en titel eller beskrivning",
    'fabric.linkPicker.linkInvalid': 'Ange en giltig webbadress.',
    'fabric.linkPicker.linkLabel': "L\xe4nk",
    'fabric.linkPicker.linkPlaceholder': "Klistra in en l\xe4nk",
    'fabric.linkPicker.linkTextAriaLabel': "Visningstext f\xf6r l\xe4nk",
    'fabric.linkPicker.linkTextLabel': 'Visningstext (valfritt)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text att visa',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Nyligen visade',
    'fabric.linkPicker.listTitle.results': 'Resultat',
    'fabric.linkPicker.search.error.description': "Uppdatera sidan eller kontakta <a>Atlassians support</a> om problemet kvarst\xe5r.",
    'fabric.linkPicker.search.error.heading': "Vi kan inte l\xe4sa in data.",
    'fabric.linkPicker.search.error.retry': 'Uppdatera',
    'fabric.linkPicker.search.linkAriaLabel': "F\xf6rslag visas nedan n\xe4r du skriver i f\xe4ltet",
    'fabric.linkPicker.search.linkLabel': "S\xf6k eller klistra in en l\xe4nk",
    'fabric.linkPicker.search.linkPlaceholder': "Hitta senaste l\xe4nkar eller klistra in en ny l\xe4nk",
    'fabric.linkPicker.search.noResults.description': "F\xf6rs\xf6k med ett annat s\xf6kord.",
    'fabric.linkPicker.search.noResults.heading': "Vi kunde inte hitta n\xe5gra tr\xe4ffar f\xf6r din s\xf6kning.",
    'fabric.linkPicker.status.submitting': 'Skickar in',
    'fabric.linkPicker.time.message.updated': 'Uppdaterades {time}',
    'fabric.linkPicker.time.message.viewed': 'Visades {time}',
    'fabric.linkPicker.unhandledError.description': "F\xf6rs\xf6k uppdatera sidan.",
    'fabric.linkPicker.unhandledError.heading': "N\xe5got gick fel!"
};

});


//# sourceMappingURL=sv.8bb6f6e5.js.map
